<script>
import { convertCurrency } from '~/assets/js/methods';
import Sumary from './Sumary.vue';
export default {
    name: 'CartItems',
    components: { Sumary },
    setup() {
        return {
            convertCurrency
        }
    },
    computed: {
        getProduct() {
            return this.$store.getters['getProduct'];
        },
        getOffer() {
            return this.$store.getters['getOffer'];
        },
        getCart() {
            return this.$store.getters['getCart'];
        },
        getSumary() {
            return this.$store.getters['getSumary'];
        },
        getPaymentMethodSelected() {
            return this.$store.getters['getPaymentMethodSelected'];
        },
        getSetup() {
            return this.$store.getters['getSetup'];
        }
    },
    methods: {
        getAmoutByItem(item) {
            let subtotal = parseInt((item.sale_price * item.quantity));
            let discount = 0;
            if (typeof item.discount_data !== 'undefined') {
                discount = parseInt(((item.sale_price * item.discount_data.percent) * item.quantity) / 100);
            }

            return {
                discount: discount,
                subtotal: subtotal,
                amount_avista: (subtotal - discount),
                unit_price: parseInt((subtotal - discount) / item.quantity)
            }

        }
    },
    data() {
        return {
            colapse: false
        }
    }
}
</script>
<template>
    <div class="bg-white rounded-md relative sm:hidden">
        <div class="flex">
            <div v-show="colapse" @click.prevent.stop="colapse = !colapse"
                class="text-base font-medium text-black leading-none w-full px-2 py-4 mr-6 items-center flex justify-between">
                <span class="text-start">RESUMO (1)</span>
                <span class="text-xl font-medium text-green-600 leading-none">{{
                    convertCurrency(getSumary.total_amount / 100, 'R$ ', 2) }}</span>
            </div>

            <div class="right-2 absolute top-1">
                <svg @click="colapse = !colapse" v-if="colapse" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 15.75l7.5-7.5 7.5 7.5" />
                </svg>

                <svg @click="colapse = !colapse" v-if="!colapse" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                </svg>
            </div>
        </div>


        <div v-show="!colapse" v-for="(item, index) in getCart" :key="index">
            <div v-if="item.operation_type === 1"
                class="flex flex-auto align-middle items-center p-2 border-b-2 last:border-b-0">
                <div :class="{ 'w-3/12': item.cover }" v-if="item.cover" class="text-start">
                    <img :src="item.cover" loading="lazy" :alt="item.title" width="200" height="200"
                        class="h-16 w-16 rounded-md inline-block" />
                </div>
                <div :class="{ 'ml-2 w-9/12': item.cover, 'w-full': !item.cover }" class="leading-none block">
                    <p class="text-base font-medium text-black leading-none block w-full">
                        {{ item.title }}
                    </p>
                    <span class="text-sm">
                        <span>Qtd: 1</span> - <span>{{ convertCurrency((item.price / 100), 'R$ ', 2) }}</span>
                    </span>
                </div>
            </div>
        </div>

        <dl v-show="!colapse" class=" border-gray-200 px-3 pb-1">
            <div class="flex items-center justify-between">
                <dt class="text-md font-bold text-left">Total:</dt>
                <dd class="text-md font-medium text-gray-900  leading-none text-right"
                    v-if="getPaymentMethodSelected === 1 && getSumary.total_amount > 0">
                    {{ convertCurrency(getSumary.total_amount / 100, 'R$ ', 2) }} ou {{ getSumary.installments }}x
                    {{ convertCurrency(getSumary.amount_installment / 100, 'R$ ', 2) }}
                </dd>
                <dd class="text-2xl font-medium text-gray-900  leading-none text-right" v-else>
                    {{ convertCurrency(getSumary.total_amount / 100, 'R$ ', 2) }}
                </dd>
            </div>
        </dl>
    </div>
</template>
